import request from "../request";

export const createLCWorkedExample = (curriculumId, lcId, levelId, data) =>
  request.post(`/assessment/${curriculumId}/learning-continuum/${lcId}/level/${levelId}/worked-examples`, data).then((res) => res);

export const updateLCWorkedExample = (curriculumId, lcId, levelId, id, data) =>
  request.put(`/assessment/${curriculumId}/learning-continuum/${lcId}/level/${levelId}/worked-examples/${id}`, data).then((res) => res);

export const deleteLCWorkedExample = (curriculumId, lcId, levelId, id) =>
  request.delete(`/assessment/${curriculumId}/learning-continuum/${lcId}/level/${levelId}/worked-examples/${id}`).then((res) => res);